<template>
    <div>
        <div class="gradient-box gradient-box-peach" />
        <div class="row" data-test-view="surveys">
            <div class="col-md-2 hidden-xs hidden-sm">
                <l-surveys-menus :rights="rights" :survey="survey"></l-surveys-menus>
            </div>
            <div class="col-md-10">
                <surveys-edit-basics
                    v-if="$route.params.section === 'basics'"
                    :auto-saving-text="autoSavingText"
                    :open-help-h-c="openHelpHC"
                    @change="updateSurvey"
                ></surveys-edit-basics>
                <surveys-edit-visibility
                    v-else-if="$route.params.section === 'visibility'"
                    :auto-saving-text="autoSavingText"
                    :open-help-h-c="openHelpHC"
                ></surveys-edit-visibility>
                <surveys-edit-questions
                    v-else-if="$route.params.section === 'questions'"
                    :auto-saving-text="autoSavingText"
                    :open-help-h-c="openHelpHC"
                    @change="updateSurvey"
                ></surveys-edit-questions>
                <surveys-edit-timing
                    v-else-if="$route.params.section === 'timing'"
                    :auto-saving-text="autoSavingText"
                    :open-help-h-c="openHelpHC"
                    @change="updateSurvey"
                ></surveys-edit-timing>
                <surveys-edit-participants
                    v-else-if="$route.params.section === 'participants'"
                    :auto-saving-text="autoSavingText"
                    :open-help-h-c="openHelpHC"
                    @change="updateSurvey"
                ></surveys-edit-participants>
                <surveys-edit-notifications
                    v-else-if="$route.params.section === 'notifications'"
                    :auto-saving-text="autoSavingText"
                    :open-help-h-c="openHelpHC"
                    @change="updateSurvey"
                ></surveys-edit-notifications>
                <surveys-edit-status
                    v-else-if="$route.params.section === 'status'"
                    :auto-saving-text="autoSavingText"
                    :open-help-h-c="openHelpHC"
                    @change="updateSurvey"
                ></surveys-edit-status>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import SurveysEditBasics from "@/views/SurveysEditBasics";
import SurveysEditVisibility from "@/views/SurveysEditVisibility";
import SurveysEditQuestions from "@/views/SurveysEditQuestions";
import SurveysEditTiming from "@/views/SurveysEditTiming";
import SurveysEditParticipants from "@/views/SurveysEditParticipants";
import SurveysEditNotifications from "@/views/SurveysEditNotifications";
import SurveysEditStatus from "@/views/SurveysEditStatus";

import icon from "@/img/icons/surveys.png";
import LSurveysMenus from "@/components/LSurveysMenus.vue";

export default {
    components: {
        LSurveysMenus,

        SurveysEditBasics,
        SurveysEditVisibility,
        SurveysEditQuestions,
        SurveysEditTiming,
        SurveysEditParticipants,
        SurveysEditNotifications,
        SurveysEditStatus,
    },
    data() {
        return {
            error: false,
            autoSavingText: "",

            survey: {},
        };
    },
    computed: {
        ...mapGetters({
            rights: "users/current/rights",
            user: "users/current/user",
            getTeamInfo: "teams/current/info",
            tags: "tags/tags/surveys",
            usersSearchList: "users/search/list",
            teamsSearchList: "teams/search/list",
            getUserList: "users/list/list",

            getDetail: "surveys/surveys/detail",
        }),
    },
    watch: {
        "$route.params.id": {
            deep: true,
            immediate: true,
            handler(id) {
                this.survey = this.getDetail(id);
            },
        },
    },
    created() {
        this.icon = icon;
    },
    methods: {
        updateSurvey(scope, survey) {
            this.autoSavingText = this.$t(`surveys.details.autoSaving`);
            this.$store
                .dispatch("surveys/surveys/updateDetail", {
                    payload: { scope, survey },
                })
                .then(data => {
                    if (this.$route.params.id === "new" && data) {
                        this.$router.push(
                            `/surveys/edit/${data._id}/${this.$route.params.section}`,
                        );
                    }
                    this.$emit("updated");
                    this.autoSavingText = "";
                });
        },
        permissionCheck(module) {
            if (this.rights.S_ACCESS_ALL) {
                return true;
            }
            return this.survey?.sharedWithMe?.scope?.includes(module);
        },

        openHelpHC() {
            window.open(
                "https://leapsome.zendesk.com/hc/en-us/categories/360000286654-Surveys",
                "_blank",
                "noopener noreferrer",
            );
        },
    },
};
</script>

<style scoped></style>
